import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "ti" }
const _hoisted_2 = { class: "ti-head" }
const _hoisted_3 = { class: "ti-kpis" }
const _hoisted_4 = { class: "ti-kpi" }
const _hoisted_5 = { class: "ti-kpi" }
const _hoisted_6 = { class: "text-warning-strong" }
const _hoisted_7 = { class: "ti-kpi" }
const _hoisted_8 = { class: "text-success-strong" }
const _hoisted_9 = { class: "ti-card" }
const _hoisted_10 = { class: "ti-filters" }
const _hoisted_11 = { class: "ti-search" }
const _hoisted_12 = { class: "table-responsive ti-table-wrap" }
const _hoisted_13 = { class: "table ti-table align-middle mb-0" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-end text-nowrap" }
const _hoisted_18 = {
  key: 0,
  class: "ti-badge tone-success"
}
const _hoisted_19 = {
  key: 1,
  class: "ti-badge tone-warning"
}
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "ti-mode-tag" }
const _hoisted_24 = { class: "text-end" }
const _hoisted_25 = { class: "dropdown" }
const _hoisted_26 = ["aria-label"]
const _hoisted_27 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  class: "ti-pager"
}
const _hoisted_36 = { class: "btn-group" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "btn btn-sm btn-primary disabled" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "ti-aside" }
const _hoisted_41 = { class: "ti-pay-head" }
const _hoisted_42 = { class: "ti-pay-sum" }
const _hoisted_43 = { class: "ti-pay-amount" }
const _hoisted_44 = {
  class: "ti-modes",
  role: "radiogroup",
  "aria-labelledby": "ti-mode-label"
}
const _hoisted_45 = ["aria-checked", "onClick"]
const _hoisted_46 = {
  key: 0,
  class: "ti-err"
}
const _hoisted_47 = { class: "ti-pay-fields" }
const _hoisted_48 = { class: "ti-input-icon" }
const _hoisted_49 = {
  key: 0,
  class: "ti-err"
}
const _hoisted_50 = { class: "ti-input-icon" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = {
  key: 0,
  class: "ti-err"
}
const _hoisted_53 = { class: "ti-pay-actions" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-5",
  role: "status"
}
const _hoisted_56 = {
  key: 1,
  class: "ti-card ti-pay-empty"
}
const _hoisted_57 = {
  key: 2,
  class: "ti-card ti-last"
}
const _hoisted_58 = {
  ref: "createEl",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "tiCreateTitle",
  "aria-hidden": "true"
}
const _hoisted_59 = { class: "modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable" }
const _hoisted_60 = { class: "modal-content" }
const _hoisted_61 = { class: "modal-body" }
const _hoisted_62 = { class: "ti-search ti-search-wide mb-15" }
const _hoisted_63 = { class: "row g-2 align-items-end mb-15" }
const _hoisted_64 = { class: "col-sm-4" }
const _hoisted_65 = ["max"]
const _hoisted_66 = { class: "col-sm-4" }
const _hoisted_67 = ["min"]
const _hoisted_68 = { class: "col-sm-4" }
const _hoisted_69 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_70 = {
  key: 1,
  class: "ti-empty-box"
}
const _hoisted_71 = { class: "table-responsive ti-bordered" }
const _hoisted_72 = { class: "table ti-table align-middle mb-0" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "text-center" }
const _hoisted_75 = ["checked", "aria-label", "onChange"]
const _hoisted_76 = { class: "text-center" }
const _hoisted_77 = { class: "text-center" }
const _hoisted_78 = { class: "text-end fw-bold" }
const _hoisted_79 = {
  key: 0,
  class: "ti-detail mt-20"
}
const _hoisted_80 = { class: "d-flex flex-wrap align-items-center justify-content-between gap-2 mb-10" }
const _hoisted_81 = { class: "mb-0" }
const _hoisted_82 = { class: "d-flex align-items-center gap-3" }
const _hoisted_83 = { class: "text-muted" }
const _hoisted_84 = { class: "table ti-table align-middle mb-0" }
const _hoisted_85 = { style: {"width":"40px"} }
const _hoisted_86 = ["checked"]
const _hoisted_87 = { key: 0 }
const _hoisted_88 = ["checked", "aria-label", "onChange"]
const _hoisted_89 = { class: "text-center" }
const _hoisted_90 = { class: "text-end" }
const _hoisted_91 = { class: "text-end fw-bold" }
const _hoisted_92 = { class: "ti-total" }
const _hoisted_93 = { colspan: "5" }
const _hoisted_94 = {
  colspan: "3",
  class: "text-end"
}
const _hoisted_95 = {
  key: 0,
  class: "ti-pager"
}
const _hoisted_96 = { class: "btn-group" }
const _hoisted_97 = ["disabled"]
const _hoisted_98 = { class: "btn btn-sm btn-primary disabled" }
const _hoisted_99 = ["disabled"]
const _hoisted_100 = { class: "modal-footer" }
const _hoisted_101 = ["disabled"]
const _hoisted_102 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-5",
  role: "status"
}
const _hoisted_103 = {
  ref: "detailsEl",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "tiDetailsTitle",
  "aria-hidden": "true"
}
const _hoisted_104 = { class: "modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable" }
const _hoisted_105 = { class: "modal-content" }
const _hoisted_106 = { class: "modal-header" }
const _hoisted_107 = {
  id: "tiDetailsTitle",
  class: "modal-title fs-5"
}
const _hoisted_108 = { class: "modal-body" }
const _hoisted_109 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_110 = { class: "ti-dl" }
const _hoisted_111 = { class: "fw-bold" }
const _hoisted_112 = { class: "table-responsive ti-bordered" }
const _hoisted_113 = { class: "table ti-table align-middle mb-0" }
const _hoisted_114 = { class: "text-center" }
const _hoisted_115 = { class: "text-end" }
const _hoisted_116 = { class: "text-end fw-bold" }
const _hoisted_117 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[29] || (_cache[29] = _createElementVNode("div", null, [
        _createElementVNode("h1", { class: "ti-title" }, "Factures transporteurs"),
        _createElementVNode("p", { class: "ti-sub" }, "Suivez et gérez les factures de vos transporteurs : sacs expédiés × tarif par sac.")
      ], -1)),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary ti-add",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreate && _ctx.openCreate(...args)))
      }, _cache[28] || (_cache[28] = [
        _createElementVNode("i", {
          class: "ph ph-plus",
          "aria-hidden": "true"
        }, null, -1),
        _createTextVNode(" Ajouter une facture ", -1)
      ]))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[31] || (_cache[31] = _createElementVNode("span", { class: "ti-kpi-icon tone-info" }, [
          _createElementVNode("i", {
            class: "ph ph-file-text",
            "aria-hidden": "true"
          })
        ], -1)),
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.stats.total), 1),
          _cache[30] || (_cache[30] = _createElementVNode("span", null, "Total des factures", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[32] || (_cache[32] = _createElementVNode("span", { class: "ti-kpi-icon tone-warning" }, [
          _createElementVNode("i", {
            class: "ph ph-clock",
            "aria-hidden": "true"
          })
        ], -1)),
        _createElementVNode("div", null, [
          _createElementVNode("strong", _hoisted_6, _toDisplayString(_ctx.stats.unpaid), 1),
          _createElementVNode("span", null, "Non payée(s) · " + _toDisplayString(_ctx.money(_ctx.stats.unpaid_amount)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[33] || (_cache[33] = _createElementVNode("span", { class: "ti-kpi-icon tone-success" }, [
          _createElementVNode("i", {
            class: "ph ph-check",
            "aria-hidden": "true"
          })
        ], -1)),
        _createElementVNode("div", null, [
          _createElementVNode("strong", _hoisted_8, _toDisplayString(_ctx.stats.paid), 1),
          _createElementVNode("span", null, "Payée(s) · " + _toDisplayString(_ctx.money(_ctx.stats.paid_amount)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["ti-layout", { 'has-panel': _ctx.payTarget }])
    }, [
      _createElementVNode("section", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[34] || (_cache[34] = _createElementVNode("i", {
              class: "ph ph-magnifying-glass",
              "aria-hidden": "true"
            }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.searchTerm) = $event)),
              type: "search",
              placeholder: "Rechercher une facture, un transporteur…",
              "aria-label": "Rechercher une facture",
              onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)))
            }, null, 544), [
              [_vModelText, _ctx.filters.searchTerm]
            ])
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.status) = $event)),
            class: "form-select ti-select",
            "aria-label": "Statut",
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fetchInvoices(1)))
          }, _cache[35] || (_cache[35] = [
            _createElementVNode("option", { value: "" }, "Tous les statuts", -1),
            _createElementVNode("option", { value: "unpaid" }, "Non payées", -1),
            _createElementVNode("option", { value: "paid" }, "Payées", -1)
          ]), 544), [
            [_vModelSelect, _ctx.filters.status]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("table", _hoisted_13, [
            _cache[46] || (_cache[46] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "N° facture"),
                _createElementVNode("th", null, "Transporteur"),
                _createElementVNode("th", { class: "text-center" }, "Sacs"),
                _createElementVNode("th", { class: "text-end" }, "Montant"),
                _createElementVNode("th", null, "Statut"),
                _createElementVNode("th", { class: "text-center" }, "Actions"),
                _createElementVNode("th", { style: {"width":"44px"} }, [
                  _createElementVNode("span", { class: "visually-hidden" }, "Menu")
                ])
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, _cache[36] || (_cache[36] = [
                    _createElementVNode("td", {
                      colspan: "7",
                      class: "text-center py-4"
                    }, [
                      _createElementVNode("span", { class: "spinner-border spinner-border-sm" })
                    ], -1)
                  ])))
                : (!_ctx.invoices.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_15, _cache[37] || (_cache[37] = [
                      _createElementVNode("td", {
                        colspan: "7",
                        class: "ti-empty"
                      }, [
                        _createElementVNode("i", {
                          class: "ph ph-receipt",
                          "aria-hidden": "true"
                        }),
                        _createTextVNode(" Aucune facture transporteur. ")
                      ], -1)
                    ])))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.invoices, (inv) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: inv.id,
                        class: _normalizeClass({ 'is-current': _ctx.payTarget?.id === inv.id })
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("strong", null, _toDisplayString(inv.ref), 1)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(inv.transport_name), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(inv.sacs), 1),
                        _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.money(inv.amount)), 1),
                        _createElementVNode("td", null, [
                          (inv.status === 'paid')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _cache[38] || (_cache[38] = [
                                _createElementVNode("i", {
                                  class: "ph-fill ph-check-circle",
                                  "aria-hidden": "true"
                                }, null, -1),
                                _createTextVNode(" Payée ", -1)
                              ])))
                            : (_openBlock(), _createElementBlock("span", _hoisted_19, _cache[39] || (_cache[39] = [
                                _createElementVNode("i", {
                                  class: "ph ph-clock",
                                  "aria-hidden": "true"
                                }, null, -1),
                                _createTextVNode(" Non payée ", -1)
                              ])))
                        ]),
                        _createElementVNode("td", _hoisted_20, [
                          (inv.status !== 'paid')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "btn btn-sm btn-primary ti-act",
                                onClick: ($event: any) => (_ctx.openPay(inv))
                              }, " Payer ", 8, _hoisted_21))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm btn-outline-secondary ti-act",
                                  onClick: ($event: any) => (_ctx.openDetails(inv))
                                }, " Voir détails ", 8, _hoisted_22),
                                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.modeLabel(inv.payment_mode)), 1)
                              ], 64))
                        ]),
                        _createElementVNode("td", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "ti-kebab",
                              "data-bs-toggle": "dropdown",
                              "data-bs-popper-config": "{\"strategy\":\"fixed\"}",
                              "aria-expanded": "false",
                              "aria-label": `Actions ${inv.ref}`
                            }, _cache[40] || (_cache[40] = [
                              _createElementVNode("i", {
                                class: "ph-bold ph-dots-three-vertical",
                                "aria-hidden": "true"
                              }, null, -1)
                            ]), 8, _hoisted_26),
                            _createElementVNode("ul", _hoisted_27, [
                              _createElementVNode("li", null, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.openDetails(inv))
                                }, _cache[41] || (_cache[41] = [
                                  _createElementVNode("i", {
                                    class: "ph ph-eye me-5",
                                    "aria-hidden": "true"
                                  }, null, -1),
                                  _createTextVNode("Voir détails ", -1)
                                ]), 8, _hoisted_28)
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.openPdf(inv))
                                }, _cache[42] || (_cache[42] = [
                                  _createElementVNode("i", {
                                    class: "ph ph-file-pdf me-5",
                                    "aria-hidden": "true"
                                  }, null, -1),
                                  _createTextVNode("PDF ", -1)
                                ]), 8, _hoisted_29)
                              ]),
                              (inv.status !== 'paid')
                                ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (_ctx.openPay(inv))
                                    }, _cache[43] || (_cache[43] = [
                                      _createElementVNode("i", {
                                        class: "ph ph-wallet me-5",
                                        "aria-hidden": "true"
                                      }, null, -1),
                                      _createTextVNode("Payer ", -1)
                                    ]), 8, _hoisted_31)
                                  ]))
                                : _createCommentVNode("", true),
                              (inv.status !== 'paid')
                                ? (_openBlock(), _createElementBlock("li", _hoisted_32, _cache[44] || (_cache[44] = [
                                    _createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
                                  ])))
                                : _createCommentVNode("", true),
                              (inv.status !== 'paid')
                                ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "dropdown-item text-danger",
                                      onClick: ($event: any) => (_ctx.remove(inv))
                                    }, _cache[45] || (_cache[45] = [
                                      _createElementVNode("i", {
                                        class: "ph ph-trash me-5",
                                        "aria-hidden": "true"
                                      }, null, -1),
                                      _createTextVNode("Supprimer ", -1)
                                    ]), 8, _hoisted_34)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ], 2))
                    }), 128))
            ])
          ])
        ]),
        (_ctx.pagination.total)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("span", null, _toDisplayString(_ctx.pagination.from || 0) + " à " + _toDisplayString(_ctx.pagination.to || 0) + " sur " + _toDisplayString(_ctx.pagination.total) + " résultat(s)", 1),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-light",
                  disabled: _ctx.pagination.current_page <= 1,
                  "aria-label": "Page précédente",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.fetchInvoices(_ctx.pagination.current_page - 1)))
                }, _cache[47] || (_cache[47] = [
                  _createElementVNode("i", {
                    class: "ph ph-caret-left",
                    "aria-hidden": "true"
                  }, null, -1)
                ]), 8, _hoisted_37),
                _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.pagination.current_page), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-light",
                  disabled: _ctx.pagination.current_page >= _ctx.pagination.last_page,
                  "aria-label": "Page suivante",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fetchInvoices(_ctx.pagination.current_page + 1)))
                }, _cache[48] || (_cache[48] = [
                  _createElementVNode("i", {
                    class: "ph ph-caret-right",
                    "aria-hidden": "true"
                  }, null, -1)
                ]), 8, _hoisted_39)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("aside", _hoisted_40, [
        (_ctx.payTarget)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              ref: "payPanel",
              class: "ti-card ti-pay",
              novalidate: "",
              onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.pay && _ctx.pay(...args)), ["prevent"]))
            }, [
              _createElementVNode("header", _hoisted_41, [
                _createElementVNode("h2", null, "Payer la facture — " + _toDisplayString(_ctx.payTarget.ref), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "aria-label": "Fermer",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closePay && _ctx.closePay(...args)))
                })
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", null, [
                  _cache[49] || (_cache[49] = _createElementVNode("small", null, "Transporteur", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.payTarget.transport_name), 1)
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _cache[50] || (_cache[50] = _createElementVNode("small", null, "Montant à payer", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.money(_ctx.payTarget.amount)), 1)
                ])
              ]),
              _cache[57] || (_cache[57] = _createElementVNode("label", {
                class: "ti-label",
                id: "ti-mode-label"
              }, "Mode de paiement", -1)),
              _createElementVNode("div", _hoisted_44, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modes, (m) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: m.value,
                    type: "button",
                    role: "radio",
                    class: _normalizeClass(["ti-mode", { 'is-active': _ctx.payForm.payment_mode === m.value }]),
                    "aria-checked": _ctx.payForm.payment_mode === m.value,
                    onClick: ($event: any) => (_ctx.setMode(m.value))
                  }, [
                    _cache[51] || (_cache[51] = _createElementVNode("span", {
                      class: "ti-radio",
                      "aria-hidden": "true"
                    }, null, -1)),
                    _createElementVNode("i", {
                      class: _normalizeClass(["ph", m.icon]),
                      "aria-hidden": "true"
                    }, null, 2),
                    _createElementVNode("strong", null, _toDisplayString(m.label), 1),
                    _createElementVNode("small", null, _toDisplayString(m.help), 1)
                  ], 10, _hoisted_45))
                }), 128))
              ]),
              (_ctx.payErrors.payment_mode)
                ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.payErrors.payment_mode), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", null, [
                  _cache[53] || (_cache[53] = _createElementVNode("label", {
                    for: "ti-pay-date",
                    class: "ti-label"
                  }, "Date de paiement", -1)),
                  _createElementVNode("div", _hoisted_48, [
                    _cache[52] || (_cache[52] = _createElementVNode("i", {
                      class: "ph ph-calendar-blank",
                      "aria-hidden": "true"
                    }, null, -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "ti-pay-date",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.payForm.payment_date) = $event)),
                      type: "date",
                      class: _normalizeClass(["form-control", { 'is-invalid': _ctx.payErrors.payment_date }])
                    }, null, 2), [
                      [_vModelText, _ctx.payForm.payment_date]
                    ])
                  ]),
                  (_ctx.payErrors.payment_date)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.payErrors.payment_date), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _cache[55] || (_cache[55] = _createElementVNode("label", {
                    for: "ti-pay-ref",
                    class: "ti-label"
                  }, "Référence du virement", -1)),
                  _createElementVNode("div", _hoisted_50, [
                    _cache[54] || (_cache[54] = _createElementVNode("i", {
                      class: "ph ph-file-text",
                      "aria-hidden": "true"
                    }, null, -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "ti-pay-ref",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.payForm.payment_reference) = $event)),
                      type: "text",
                      maxlength: "100",
                      class: _normalizeClass(["form-control", { 'is-invalid': _ctx.payErrors.payment_reference }]),
                      disabled: _ctx.payForm.payment_mode !== 'transfer',
                      placeholder: "Ex. VIR-0001"
                    }, null, 10, _hoisted_51), [
                      [_vModelText, _ctx.payForm.payment_reference]
                    ])
                  ]),
                  (_ctx.payErrors.payment_reference)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.payErrors.payment_reference), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _cache[58] || (_cache[58] = _createElementVNode("small", { class: "ti-hint" }, [
                _createElementVNode("i", {
                  class: "ph ph-info",
                  "aria-hidden": "true"
                }),
                _createTextVNode(" La référence du virement apparaît uniquement pour un paiement par virement. ")
              ], -1)),
              _cache[59] || (_cache[59] = _createElementVNode("p", { class: "ti-info" }, [
                _createElementVNode("i", {
                  class: "ph-fill ph-info",
                  "aria-hidden": "true"
                }),
                _createElementVNode("span", null, [
                  _createTextVNode("Après confirmation, la facture passe à "),
                  _createElementVNode("strong", null, "Payée"),
                  _createTextVNode(".")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closePay && _ctx.closePay(...args)))
                }, "Annuler"),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary",
                  disabled: _ctx.paying
                }, [
                  (_ctx.paying)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_55))
                    : _createCommentVNode("", true),
                  _cache[56] || (_cache[56] = _createTextVNode(" Confirmer le paiement ", -1))
                ], 8, _hoisted_54)
              ])
            ], 544))
          : (_openBlock(), _createElementBlock("div", _hoisted_56, _cache[60] || (_cache[60] = [
              _createElementVNode("i", {
                class: "ph ph-hand-pointing",
                "aria-hidden": "true"
              }, null, -1),
              _createElementVNode("p", null, [
                _createTextVNode("Cliquez sur "),
                _createElementVNode("strong", null, "Payer"),
                _createTextVNode(" dans la liste pour régler une facture.")
              ], -1)
            ]))),
        (_ctx.lastPaid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
              _createElementVNode("header", null, [
                _createElementVNode("h3", null, "Dernière facture payée — " + _toDisplayString(_ctx.lastPaid.ref), 1),
                _cache[61] || (_cache[61] = _createElementVNode("span", { class: "ti-badge tone-success" }, [
                  _createElementVNode("i", {
                    class: "ph-fill ph-check-circle",
                    "aria-hidden": "true"
                  }),
                  _createTextVNode(" Payée")
                ], -1))
              ]),
              _createElementVNode("dl", null, [
                _cache[62] || (_cache[62] = _createElementVNode("dt", null, [
                  _createElementVNode("i", {
                    class: "ph ph-truck",
                    "aria-hidden": "true"
                  }),
                  _createTextVNode(" Transporteur :")
                ], -1)),
                _createElementVNode("dd", null, _toDisplayString(_ctx.lastPaid.transport_name), 1),
                _cache[63] || (_cache[63] = _createElementVNode("dt", null, [
                  _createElementVNode("i", {
                    class: "ph ph-money",
                    "aria-hidden": "true"
                  }),
                  _createTextVNode(" Mode :")
                ], -1)),
                _createElementVNode("dd", null, [
                  _createTextVNode(_toDisplayString(_ctx.modeLabel(_ctx.lastPaid.payment_mode)), 1),
                  (_ctx.lastPaid.payment_reference)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" · " + _toDisplayString(_ctx.lastPaid.payment_reference), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _cache[64] || (_cache[64] = _createElementVNode("dt", null, [
                  _createElementVNode("i", {
                    class: "ph ph-calendar-blank",
                    "aria-hidden": "true"
                  }),
                  _createTextVNode(" Date :")
                ], -1)),
                _createElementVNode("dd", null, _toDisplayString(_ctx.date(_ctx.lastPaid.payment_date)), 1),
                _cache[65] || (_cache[65] = _createElementVNode("dt", null, [
                  _createElementVNode("i", {
                    class: "ph ph-coins",
                    "aria-hidden": "true"
                  }),
                  _createTextVNode(" Montant :")
                ], -1)),
                _createElementVNode("dd", null, _toDisplayString(_ctx.money(_ctx.lastPaid.amount)), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "ti-link",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openDetails(_ctx.lastPaid)))
              }, _cache[66] || (_cache[66] = [
                _createElementVNode("i", {
                  class: "ph ph-clock-counter-clockwise",
                  "aria-hidden": "true"
                }, null, -1),
                _createTextVNode(" Historique ", -1)
              ]))
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_58, [
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("div", _hoisted_60, [
          _cache[86] || (_cache[86] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", {
                id: "tiCreateTitle",
                class: "modal-title fs-5"
              }, "Ajouter une facture"),
              _createElementVNode("small", { class: "text-primary" }, "Transporteurs avec des sacs expédiés non encore facturés.")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _cache[67] || (_cache[67] = _createElementVNode("i", {
                class: "ph ph-magnifying-glass",
                "aria-hidden": "true"
              }, null, -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.createSearch) = $event)),
                type: "search",
                placeholder: "Rechercher un transporteur…",
                "aria-label": "Rechercher un transporteur",
                onInput: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onCreateSearch && _ctx.onCreateSearch(...args)))
              }, null, 544), [
                [_vModelText, _ctx.createSearch]
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _cache[68] || (_cache[68] = _createElementVNode("label", {
                  for: "ti-date-from",
                  class: "ti-label"
                }, "Expédié du", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "ti-date-from",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dateFrom) = $event)),
                  type: "date",
                  class: "form-control",
                  max: _ctx.dateTo || undefined,
                  onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.loadTransports && _ctx.loadTransports(...args)))
                }, null, 40, _hoisted_65), [
                  [_vModelText, _ctx.dateFrom]
                ])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _cache[69] || (_cache[69] = _createElementVNode("label", {
                  for: "ti-date-to",
                  class: "ti-label"
                }, "au", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "ti-date-to",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.dateTo) = $event)),
                  type: "date",
                  class: "form-control",
                  min: _ctx.dateFrom || undefined,
                  onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.loadTransports && _ctx.loadTransports(...args)))
                }, null, 40, _hoisted_67), [
                  [_vModelText, _ctx.dateTo]
                ])
              ]),
              _createElementVNode("div", _hoisted_68, [
                (_ctx.dateFrom || _ctx.dateTo)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-light",
                      onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.resetDates && _ctx.resetDates(...args)))
                    }, _cache[70] || (_cache[70] = [
                      _createElementVNode("i", {
                        class: "ph ph-x me-5",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createTextVNode("Réinitialiser les dates ", -1)
                    ])))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.loadingUninvoiced && !_ctx.transports.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_69, _cache[71] || (_cache[71] = [
                  _createElementVNode("span", { class: "spinner-border spinner-border-sm" }, null, -1)
                ])))
              : (!_ctx.transports.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                    _cache[72] || (_cache[72] = _createElementVNode("i", {
                      class: "ph ph-truck",
                      "aria-hidden": "true"
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.createSearch || _ctx.dateFrom || _ctx.dateTo ? "Aucun bon ne correspond aux filtres." : "Aucun bon d'envoi expédié à facturer."), 1)
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("table", _hoisted_72, [
                        _cache[73] || (_cache[73] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { style: {"width":"90px"} }, "Sélection"),
                            _createElementVNode("th", null, "Transporteur"),
                            _createElementVNode("th", { class: "text-center" }, "Nombre de bons"),
                            _createElementVNode("th", { class: "text-center" }, "Nombre de sacs"),
                            _createElementVNode("th", { class: "text-end" }, "Total à payer")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transports, (t) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: t.transport_id,
                              class: _normalizeClass(["ti-pick", { 'is-selected': _ctx.selectedId === t.transport_id }]),
                              onClick: ($event: any) => (_ctx.selectTransport(t.transport_id))
                            }, [
                              _createElementVNode("td", _hoisted_74, [
                                _createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "radio",
                                  name: "ti-transport",
                                  checked: _ctx.selectedId === t.transport_id,
                                  "aria-label": `Sélectionner ${t.transport_name}`,
                                  onChange: ($event: any) => (_ctx.selectTransport(t.transport_id))
                                }, null, 40, _hoisted_75)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("strong", null, _toDisplayString(t.transport_name), 1)
                              ]),
                              _createElementVNode("td", _hoisted_76, _toDisplayString(t.notes_count), 1),
                              _createElementVNode("td", _hoisted_77, _toDisplayString(t.sacs), 1),
                              _createElementVNode("td", _hoisted_78, _toDisplayString(_ctx.money(t.amount)), 1)
                            ], 10, _hoisted_73))
                          }), 128))
                        ])
                      ])
                    ]),
                    (_ctx.selected)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("h3", _hoisted_81, "Bons d'envoi de " + _toDisplayString(_ctx.selected.transport_name), 1),
                            _createElementVNode("div", _hoisted_82, [
                              _createElementVNode("small", _hoisted_83, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.selection.count), 1),
                                _createTextVNode(" / " + _toDisplayString(_ctx.selected.notes_count) + " bon(s) sélectionné(s) ", 1)
                              ]),
                              (_ctx.selection.count < _ctx.selected.notes_count)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "ti-link",
                                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setAllMatching(true)))
                                  }, " Tout sélectionner (" + _toDisplayString(_ctx.selected.notes_count) + ") ", 1))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "ti-link",
                                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.setAllMatching(false)))
                                  }, "Tout désélectionner"))
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["table-responsive", { 'opacity-50': _ctx.loadingNotes }])
                          }, [
                            _createElementVNode("table", _hoisted_84, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", _hoisted_85, [
                                    _createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      checked: _ctx.pageAllChecked,
                                      "aria-label": "Sélectionner les bons de cette page",
                                      onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.togglePage($event.target.checked)))
                                    }, null, 40, _hoisted_86)
                                  ]),
                                  _cache[74] || (_cache[74] = _createElementVNode("th", null, "Référence", -1)),
                                  _cache[75] || (_cache[75] = _createElementVNode("th", null, "Statut", -1)),
                                  _cache[76] || (_cache[76] = _createElementVNode("th", null, "Expédié le", -1)),
                                  _cache[77] || (_cache[77] = _createElementVNode("th", null, "Zone", -1)),
                                  _cache[78] || (_cache[78] = _createElementVNode("th", { class: "text-center" }, "Sacs", -1)),
                                  _cache[79] || (_cache[79] = _createElementVNode("th", { class: "text-end" }, "Tarif par sac", -1)),
                                  _cache[80] || (_cache[80] = _createElementVNode("th", { class: "text-end" }, "Montant", -1))
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_ctx.loadingNotes && !_ctx.notes.length)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_87, _cache[81] || (_cache[81] = [
                                      _createElementVNode("td", {
                                        colspan: "8",
                                        class: "text-center py-3"
                                      }, [
                                        _createElementVNode("span", { class: "spinner-border spinner-border-sm" })
                                      ], -1)
                                    ])))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes, (n) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: n.id,
                                    class: _normalizeClass({ 'is-selected': _ctx.isChecked(n) })
                                  }, [
                                    _createElementVNode("td", null, [
                                      _createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        checked: _ctx.isChecked(n),
                                        "aria-label": `Sélectionner ${n.note_ref}`,
                                        onChange: ($event: any) => (_ctx.setNote(n, $event.target.checked))
                                      }, null, 40, _hoisted_88)
                                    ]),
                                    _createElementVNode("td", null, _toDisplayString(n.note_ref), 1),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["ti-badge", _ctx.noteStatus(n).tone])
                                      }, _toDisplayString(_ctx.noteStatus(n).label), 3)
                                    ]),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.date(n.sent_time)), 1),
                                    _createElementVNode("td", null, _toDisplayString(n.zone || "—"), 1),
                                    _createElementVNode("td", _hoisted_89, _toDisplayString(n.sacs), 1),
                                    _createElementVNode("td", _hoisted_90, _toDisplayString(n.price_per_bag !== null ? _ctx.money(n.price_per_bag) : "—"), 1),
                                    _createElementVNode("td", _hoisted_91, _toDisplayString(_ctx.money(n.amount)), 1)
                                  ], 2))
                                }), 128))
                              ]),
                              _createElementVNode("tfoot", null, [
                                _createElementVNode("tr", _hoisted_92, [
                                  _createElementVNode("td", _hoisted_93, "Total sélectionné (" + _toDisplayString(_ctx.selection.count) + " bon(s))", 1),
                                  _createElementVNode("td", _hoisted_94, _toDisplayString(_ctx.selection.sacs) + " sacs — " + _toDisplayString(_ctx.money(_ctx.selection.amount)), 1)
                                ])
                              ])
                            ])
                          ], 2),
                          (_ctx.notesPager.total)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.notesPager.from || 0) + " à " + _toDisplayString(_ctx.notesPager.to || 0) + " sur " + _toDisplayString(_ctx.notesPager.total) + " bon(s)", 1),
                                _createElementVNode("div", _hoisted_96, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-light",
                                    disabled: _ctx.loadingNotes || _ctx.notesPager.current_page <= 1,
                                    "aria-label": "Page précédente",
                                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.loadNotes(_ctx.notesPager.current_page - 1)))
                                  }, _cache[82] || (_cache[82] = [
                                    _createElementVNode("i", {
                                      class: "ph ph-caret-left",
                                      "aria-hidden": "true"
                                    }, null, -1)
                                  ]), 8, _hoisted_97),
                                  _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.notesPager.current_page) + " / " + _toDisplayString(_ctx.notesPager.last_page), 1),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-light",
                                    disabled: _ctx.loadingNotes || _ctx.notesPager.current_page >= _ctx.notesPager.last_page,
                                    "aria-label": "Page suivante",
                                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.loadNotes(_ctx.notesPager.current_page + 1)))
                                  }, _cache[83] || (_cache[83] = [
                                    _createElementVNode("i", {
                                      class: "ph ph-caret-right",
                                      "aria-hidden": "true"
                                    }, null, -1)
                                  ]), 8, _hoisted_99)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _cache[84] || (_cache[84] = _createElementVNode("p", { class: "ti-info mt-15 mb-0" }, [
                            _createElementVNode("i", {
                              class: "ph ph-info",
                              "aria-hidden": "true"
                            }),
                            _createTextVNode(" Données issues des bons d'envoi expédiés. Les sacs déjà facturés sont exclus. La sélection s'applique à toutes les pages. ")
                          ], -1))
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
          ]),
          _createElementVNode("div", _hoisted_100, [
            _cache[85] || (_cache[85] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              "data-bs-dismiss": "modal"
            }, "Annuler", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              disabled: !_ctx.selected || _ctx.selection.count <= 0 || _ctx.creating,
              onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.createInvoice && _ctx.createInvoice(...args)))
            }, [
              (_ctx.creating)
                ? (_openBlock(), _createElementBlock("span", _hoisted_102))
                : _createCommentVNode("", true),
              _createTextVNode(" Créer la facture" + _toDisplayString(_ctx.selected ? ` — ${_ctx.selected.transport_name}` : ""), 1)
            ], 8, _hoisted_101)
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_103, [
      _createElementVNode("div", _hoisted_104, [
        _createElementVNode("div", _hoisted_105, [
          _createElementVNode("div", _hoisted_106, [
            _createElementVNode("h2", _hoisted_107, [
              _createTextVNode(" Facture " + _toDisplayString(_ctx.details?.ref) + " ", 1),
              (_ctx.details)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["ti-badge ms-5", _ctx.details.status === 'paid' ? 'tone-success' : 'tone-warning'])
                  }, _toDisplayString(_ctx.details.status === "paid" ? "Payée" : "Non payée"), 3))
                : _createCommentVNode("", true)
            ]),
            _cache[87] || (_cache[87] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_108, [
            (_ctx.loadingDetails)
              ? (_openBlock(), _createElementBlock("div", _hoisted_109, _cache[88] || (_cache[88] = [
                  _createElementVNode("span", { class: "spinner-border spinner-border-sm" }, null, -1)
                ])))
              : (_ctx.details)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("dl", _hoisted_110, [
                      _cache[92] || (_cache[92] = _createElementVNode("dt", null, [
                        _createElementVNode("i", {
                          class: "ph ph-truck",
                          "aria-hidden": "true"
                        }),
                        _createTextVNode(" Transporteur")
                      ], -1)),
                      _createElementVNode("dd", null, _toDisplayString(_ctx.details.transport_name), 1),
                      _cache[93] || (_cache[93] = _createElementVNode("dt", null, [
                        _createElementVNode("i", {
                          class: "ph ph-coins",
                          "aria-hidden": "true"
                        }),
                        _createTextVNode(" Montant")
                      ], -1)),
                      _createElementVNode("dd", _hoisted_111, _toDisplayString(_ctx.money(_ctx.details.amount)) + " (" + _toDisplayString(_ctx.details.sacs) + " sacs, " + _toDisplayString(_ctx.details.notes_count) + " bon(s))", 1),
                      _cache[94] || (_cache[94] = _createElementVNode("dt", null, [
                        _createElementVNode("i", {
                          class: "ph ph-calendar-plus",
                          "aria-hidden": "true"
                        }),
                        _createTextVNode(" Créée le")
                      ], -1)),
                      _createElementVNode("dd", null, [
                        _createTextVNode(_toDisplayString(_ctx.date(_ctx.details.created_at)), 1),
                        (_ctx.details.created_by_name)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" par " + _toDisplayString(_ctx.details.created_by_name), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.details.status === 'paid')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[90] || (_cache[90] = _createElementVNode("dt", null, [
                              _createElementVNode("i", {
                                class: "ph ph-wallet",
                                "aria-hidden": "true"
                              }),
                              _createTextVNode(" Mode")
                            ], -1)),
                            _createElementVNode("dd", null, _toDisplayString(_ctx.modeLabel(_ctx.details.payment_mode)), 1),
                            _cache[91] || (_cache[91] = _createElementVNode("dt", null, [
                              _createElementVNode("i", {
                                class: "ph ph-calendar-check",
                                "aria-hidden": "true"
                              }),
                              _createTextVNode(" Date de paiement")
                            ], -1)),
                            _createElementVNode("dd", null, [
                              _createTextVNode(_toDisplayString(_ctx.date(_ctx.details.payment_date)), 1),
                              (_ctx.details.paid_by_name)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" par " + _toDisplayString(_ctx.details.paid_by_name), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.details.payment_reference)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _cache[89] || (_cache[89] = _createElementVNode("dt", null, [
                                    _createElementVNode("i", {
                                      class: "ph ph-hash",
                                      "aria-hidden": "true"
                                    }),
                                    _createTextVNode(" Référence")
                                  ], -1)),
                                  _createElementVNode("dd", null, _toDisplayString(_ctx.details.payment_reference), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_112, [
                      _createElementVNode("table", _hoisted_113, [
                        _cache[95] || (_cache[95] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Référence"),
                            _createElementVNode("th", null, "Expédié le"),
                            _createElementVNode("th", null, "Zone"),
                            _createElementVNode("th", { class: "text-center" }, "Sacs"),
                            _createElementVNode("th", { class: "text-end" }, "Tarif par sac"),
                            _createElementVNode("th", { class: "text-end" }, "Montant")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details.notes, (n) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: n.id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(n.note_ref), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.date(n.sent_time)), 1),
                              _createElementVNode("td", null, _toDisplayString(n.zone || "—"), 1),
                              _createElementVNode("td", _hoisted_114, _toDisplayString(n.sacs), 1),
                              _createElementVNode("td", _hoisted_115, _toDisplayString(n.price_per_bag !== null ? _ctx.money(n.price_per_bag) : "—"), 1),
                              _createElementVNode("td", _hoisted_116, _toDisplayString(_ctx.money(n.amount)), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_117, [
            _cache[97] || (_cache[97] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              "data-bs-dismiss": "modal"
            }, "Fermer", -1)),
            (_ctx.details)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-outline-secondary",
                  onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.openPdf(_ctx.details)))
                }, _cache[96] || (_cache[96] = [
                  _createElementVNode("i", {
                    class: "ph ph-file-pdf me-5",
                    "aria-hidden": "true"
                  }, null, -1),
                  _createTextVNode("PDF ", -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.details && _ctx.details.status !== 'paid')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.payFromDetails && _ctx.payFromDetails(...args)))
                }, "Payer"))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 512)
  ]))
}